export default __webpack_public_path__ + "static/skyweaver-logo-fe2d37d78f8b0c28a118b66f288d8a49.png";